import PropTypes from 'prop-types';
import React from 'react';

class Radio extends React.Component {
	render() {
		const { id, name, title, checked, handleChange } = this.props;

		return (
			<div className="input">
				<label htmlFor={id}>{title}</label>
				<input type="radio" name={name} id={id} onChange={handleChange} defaultChecked={checked} />
			</div>
		);
	}
}

export default Radio;

Radio.propTypes = {
	checked: PropTypes.bool,
	handleChange: PropTypes.func,
	id: PropTypes.string,
	name: PropTypes.number,
	title: PropTypes.string,
};
